import React, {Component} from 'react';
import {
  Layout,
  Card,
  Badge,
  Button,
  Select,
  TextField,
  DataTable,
  Spinner,
} from '@shopify/polaris';

import Container from 'components/Container';
import {generateCodes, getRequests, downloadRequestCsv} from 'api/user';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codes: [{
        codeType: 'tokens',
        value: '',
        count: 0,
      }],
      requests: [],
      loadingRequests: true,
      generating: false,
    };
  }

  componentDidMount() {
    this.fetchRequests();
  }

  componentWillUnmount() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
    }
  }

  startPolling = () => {
    if (this._pollTimer) return;
    this._pollTimer = setInterval(() => {
      this.fetchRequests(true);
    }, 5000);
  }

  stopPolling = () => {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
  }

  fetchRequests = async (silent) => {
    if (!silent) {
      this.setState({ loadingRequests: true });
    }
    try {
      const requests = await getRequests();
      this.setState({ requests, loadingRequests: false });
      var hasPending = requests.some(function(r) { return r.status === 'pending'; });
      if (hasPending) {
        this.startPolling();
      } else {
        this.stopPolling();
      }
    } catch (e) {
      this.setState({ loadingRequests: false });
    }
  }

  onClickGenerate = async () => {
    if (!this.state.codes.length) {
      alert("Please input all values");
      return;
    }
    const data = {
      codes: this.state.codes.map(code => ({
        type: code.codeType,
        count: parseInt(code.count, 10),
        value: code.codeType === 'product' ? code.value : parseInt(code.value, 10)
      })),
    }
    for (var i=0; i<data.codes.length; i++) {
      const code = data.codes[i];
      if (!code.value || !code.count) {
        alert("Please input all values");
        return;
      }
    }
    this.setState({ generating: true });
    await generateCodes(data);
    this.setState({
      generating: false,
      codes: [{
        codeType: 'tokens',
        value: '',
        count: 0,
      }],
    });
    this.fetchRequests();
  }

  addCode = () => {
    this.setState({
      codes: [
        ...this.state.codes,
        {
          codeType: 'tokens',
          value: '',
          count: 0,
        },
      ]
    })
  }

  removeCode = () => {
    var codes = [...this.state.codes];
    codes.splice(-1);
    this.setState({codes})
  }

  updateField = (index, key, value) => {
    var codes = [...this.state.codes];
    codes[index][key] = value;
    this.setState({codes})
  }

  renderRow = (i) => {
    const options = [
      {label: 'Tokens', value: 'tokens'},
      {label: 'Product', value: 'product'},
    ];
    return (
      <div style={{gridTemplateColumns: '1fr 1fr 1fr', gap: 20, display: 'grid'}} key={i}>
        <Select
          label="Code Type"
          options={options}
          onChange={codeType => this.updateField(i, 'codeType', codeType)}
          value={this.state.codes[i].codeType}
        />
        <TextField helpText="Use product handle for product type code" type="text" label="Value" value={this.state.codes[i].value} onChange={value => this.updateField(i, 'value', value)} />
        <TextField type="number" label="Number of codes" value={this.state.codes[i].count} onChange={count => this.updateField(i, 'count', count)} />
      </div>
    )
  }

  formatDate = (timestamp) => {
    if (!timestamp) return '—';
    const date = timestamp._seconds ? new Date(timestamp._seconds * 1000) : new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit',
    });
  }

  renderRequests = () => {
    const { requests, loadingRequests } = this.state;

    if (loadingRequests) {
      return (
        <Card sectioned title="Previous Batches">
          <div style={{ textAlign: 'center', padding: 20 }}>
            <Spinner size="small" />
          </div>
        </Card>
      );
    }

    if (!requests.length) {
      return (
        <Card sectioned title="Previous Batches">
          <p>No code batches generated yet.</p>
        </Card>
      );
    }

    const rows = requests.map(req => {
      const summary = (req.codes || [])
        .map(c => `${c.count} × ${c.type}${c.type === 'tokens' ? ` (${c.value})` : ` (${c.value})`}`)
        .join(', ');

      return [
        this.formatDate(req.createdAt),
        summary,
        req.totalCodes || '—',
        req.status === 'complete'
          ? <Badge status="success">Complete</Badge>
          : <Badge status="attention">Processing</Badge>,
        req.status === 'complete'
          ? <Button size="slim" onClick={() => downloadRequestCsv(req.id)}>Download CSV</Button>
          : '—',
      ];
    });

    return (
      <Card title="Previous Batches">
        <DataTable
          columnContentTypes={['text', 'text', 'numeric', 'text', 'text']}
          headings={['Date', 'Codes', 'Total', 'Status', '']}
          rows={rows}
        />
      </Card>
    );
  }

  render() {
    var rows = [];
    for (var i = 0; i < this.state.codes.length; i++) {
      rows.push(this.renderRow(i));
    }
    return (
      <Container pageProps={{
        title: 'Generate New Codes',
        subtitle: 'Generate codes and download as CSV',
        fullWidth: true,
      }}>
        <React.Fragment>
          <Layout.Section>
            <Card sectioned>
              {rows}
              <div style={{display: 'flex', gap: 20}}>
                <Button onClick={this.addCode}>Add Row</Button>
                {
                  this.state.codes.length > 1 && <Button onClick={this.removeCode}>Remove Row</Button>
                }
              </div>
              <br />
              <br />
              <Button
                primary
                loading={this.state.generating}
                onClick={this.onClickGenerate}
              >
                Generate
              </Button>
            </Card>
          </Layout.Section>
          <Layout.Section>
            {this.renderRequests()}
          </Layout.Section>
        </React.Fragment>
      </Container>
    );
  }
}
export default Home;
